<div class="ssbWrapper">
  <ng-container *ngIf="isCatDiscountApplicable || isCatDiscountAppliedPublic else otherDiscounts">
    <img src="./images/cat-logo.svg" alt="CAT-logo">
    <h2>{{ appCopy.panelHeader['catDiscountTitle'+selectedLanguage] }}</h2>
    <p>{{ appCopy.panelHeader['catDiscountDescription'+selectedLanguage].replace('%s',
      appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</p>
    <div class="checkbox checkbox--default margin-bottom-24">
      <input type="checkbox" name="publicTransportCat" id="publicTransportCat" (click)="catDiscount($event)"
        [ngModel]='isCatDiscountAppliedPublic'>
      <label for="publicTransportCat">{{ appCopy.panelHeader['catDiscountCheckLabel'+selectedLanguage].replace('%s',
        appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
    </div>
    <p>{{ appCopy.panelHeader['catDiscountNote'+selectedLanguage].replace('%s',
      appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</p>
  </ng-container>

  <ng-template #otherDiscounts>
    <ng-container *ngIf="isSbbSubsidyApplicable || isSubsidyAppliedPublic else DBLHSubsidy">
      <img src="./images/SBB_CFF_FFS_logo.svg" alt="SBB_CFF_FFS_logo">
      <h2>{{ appCopy.panelHeader['sbbDiscountTitle'+selectedLanguage] }}</h2>
      <p>{{ appCopy.panelHeader['sbbDiscountDescription'+selectedLanguage].replace('%s',
        appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</p>
      <div class="checkbox checkbox--default margin-bottom-24">
        <input type="checkbox" name="publicTransportSBB" id="publicTransportSBB"
          (click)="publicTransportSubsidy($event)" [ngModel]='isSubsidyAppliedPublic'>
        <label for="publicTransportSBB">{{ appCopy.panelHeader['sbbDiscountCheckLabel'+selectedLanguage].replace('%s',
          appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
      </div>
    </ng-container>

    <ng-template #DBLHSubsidy>
      <img src="./images/Db-bahn.svg" width="140" alt="Db-bahn_logo">
      <h2>{{ appCopy.panelHeader['sbbDiscountTitle'+selectedLanguage] }}</h2>
      <p>{{ appCopy.panelHeader['sbbDBDiscountTitle'+selectedLanguage] }}</p>
    </ng-template>

    <ng-container *ngIf="isRailOnly else notRail">
      <ng-container *ngIf="isLhSubsidyApplicable || isLhSubsidyAppliedPublic">
        <div class="checkbox checkbox--default margin-bottom-24">
          <input type="checkbox" name="publicTransportLH" id="publicTransportLH"
            (click)="publicTransportLHSubsidy($event)" [ngModel]='isLhSubsidyAppliedPublic'>
          <label for="publicTransportLH">{{
            appCopy.panelHeader['sbbLHDiscountCheckLabel'+selectedLanguage].replace('%s',
            appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #notRail>
      <ng-container *ngIf="isDbSubsidyApplicable || isDbSubsidyAppliedPublic">
        <div class="checkbox checkbox--default margin-bottom-24">
          <input type="checkbox" name="publicTransportDB" id="publicTransportDB"
            (click)="publicTransportDBSubsidy($event)" [ngModel]='isDbSubsidyAppliedPublic'>
          <label for="publicTransportDB">{{
            appCopy.panelHeader['sbbDBDiscountCheckLabel'+selectedLanguage].replace('%s',
            appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
        </div>

        <ng-container *ngIf="isLhSubsidyApplicable || isLhSubsidyAppliedPublic">
          <div class="checkbox checkbox--default margin-bottom-24">
            <input type="checkbox" name="publicTransportLH" id="publicTransportLH"
              (click)="publicTransportLHSubsidy($event)" [ngModel]='isLhSubsidyAppliedPublic'>
            <label for="publicTransportLH">{{
              appCopy.panelHeader['sbbLHDiscountCheckLabel'+selectedLanguage].replace('%s',
              appAirportCopy[airportCode]["airportName" + this.selectedLanguage]) }}</label>
          </div>
        </ng-container>

      </ng-container>
    </ng-template>
  </ng-template>
</div>